/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/hashedHotCard/types";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";
import moment from "moment";
import { isArray } from "lodash";

interface Props {
  data?: Data[];
}

interface RowData {
  id: string;
  Name: string;
  Salt: string;
  FullURL: string;
  DeltaURL: string;
  UpdatedAt: string;
  CreatedAt: string;
}

const formatDate = (date: string) => moment(date).format('DD-MM-YYYY HH:mm:ss');

const mapDataToTable = (list: Data[] = []): RowData[] => {
  if ( list  && isArray(list)) {
    return list.map(({ id, attributes, updatedAt, createdAt }) => ({
      id,
      Name: attributes.Name,
      Salt: attributes.Salt,
      FullURL: attributes.FullURL,
      DeltaURL: attributes.DeltaURL,
      UpdatedAt: formatDate(updatedAt),
      CreatedAt: formatDate(createdAt),
    }))
  }
  else {
    return [{
      id: "",
      //@ts-ignore
      attributes: {
        Name:  "",
        Salt: "",
        FullURL:  "",
        DeltaURL:  "",
      },
      UpdatedAt:  "",
      CreatedAt:  "",
    }]
  }
};

export default function HashedHotCardTable({ data = [] }: Props) {
  const history = useHistory();

  const tableData = useMemo(() => mapDataToTable(data), [data]);

  const viewAction = useCallback(
    (rowData: RowData) => {
      history.push(`/hotcard/view/${rowData.id}`);
    },
    [history]
  );

  const editAction = (rowData: RowData) => {
    history.push(`/hotcard/edit/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Name",
        accessorKey: "Name",
        size: 100, // Compress column size
        minSize: 80,
        maxSize: 120,
      },
      {
        header: "FullURL",
        accessorKey: "FullURL",
        size: 150, // Compress column size
        minSize: 120,
        maxSize: 180,
      },
      {
        header: "DeltaURL",
        accessorKey: "DeltaURL",
        size: 150, // Compress column size
        minSize: 120,
        maxSize: 180,
      },
      {
        header: "Salt",
        accessorKey: "Salt",
        size: 80, // Compress column size
        minSize: 60,
        maxSize: 100,
      },
      {
        header: "Updated At",
        accessorKey: "UpdatedAt",
        size: 120, // Compress column size
        minSize: 100,
        maxSize: 140,
      },
      {
        header: "Created At",
        accessorKey: "CreatedAt",
        size: 120, // Compress column size
        minSize: 100,
        maxSize: 140,
      },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={tableData}
      getRowId={(row) => row.id}
      initialState={{
        showGlobalFilter: true,
        density: "compact", // Use "compact" density for smaller row height
      }}
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 50, // Compress action column size
        },
      }}
      enableRowActions
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <TableActions
            section="HashedHotCard"
            onView={() => viewAction(row.original)}
            onEdit={() => editAction(row.original)}
            />
        </div>
      )}
    />
  );
}
